import { isThisSecond } from 'date-fns';
import React, { Component, useEffect, useState } from 'react';
import ModalAlert from '../../components/ModalAlert';
import { getCurrency, setTopupInfo } from '../../utils/common';
import t from '../../utils/translateUtil';
import { isValidEmail, newGUID } from '../../utils/util';
import crmservices from '../../wsclient/crmservices';
import { cignalservices } from '../../wsclient/crmservices/cignalservices';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';
import AddCard from '../order-cards/AddCard';
import PaymentForm from './PaymentForm';
import TopupWalletView from './TopupWalletView';
import AutomateWalletView from './AutomateWalletView';
import { portalCfg, paths } from '../../../portal.router.config';
import { domainName } from '../../../portal.config';
import Cookies from 'js-cookie';
export default function TopupWalletController(props) {

    const [showLoading, onShowLoading] = useState(false);
    const [wallet, setWallet] = useState(null);
    const [primary_card, setPrimaryCard] = useState(null);
    const [cards, setCards] = useState([]);
    const [cardSelect, setCardSelect] = useState({});
    const [amount, setAmount] = useState(null);
    const [error, setError] = useState({});
    const [validation, setValidation] = useState(undefined);
    const [showAddCard, setShowAddCard] = useState(false);
    const [html_add_card_content, setHtmlAddCardConten] = useState(null);
    const [showPaymentForm, setShowPaymentForm] = useState(false);
    const [paymentFormData, setPaymentFormData] = useState(null);
    const [showAutomateWallet, setShowAutomateWallet] = useState(false);
    const [automateInfo, setAutomateInfo] = useState({});
    const [contact, setContact] = useState({});
    const currency = getCurrency();

    useEffect(() => {
        init();
    }, [])
    const init = async () => {
        onShowLoading(true);
        onLoadCards();
        await onLoadWallet();
        if (domainName == 'cignal') {
            onLoadContact();
        }
        onShowLoading(false);
    }

    const onLoadContact = async () => {
        try {
            var result = await crmservices.contacts.getContact();
            if (result.code === 'OK') {
                setContact(result.data)
            }
        } catch (error) {
            console.log("load contact error:", error);
        }
    }

    const onLoadCards = async () => {
        try {
            var result = await crmservices.contacts.getListPaymentMethods();
            //console.log('onLoadCards  result=', result)
            if (result.code == 'OK') {
                var cards = result.data && result.data.content ? result.data.content : [];
                if (cards.length > 0) {
                    setCards(cards)
                    var cardPrimary = cards.filter(card => {
                        return card.is_primary
                    })
                    if (cardPrimary && cardPrimary.length > 0) {
                        setCardSelect(cardPrimary[0])
                    } else {
                        setCardSelect(cards[0])
                    }
                }
            }
        } catch (error) {
            console.log("load my order exception:", error);
        }
    }
    const onLoadWallet = async () => {
        try {
            var result = await crmservices.account.getWalletInfo();
            console.log("AAAAAA load wallet:", result);
            if (result.code === 'OK') {
                setWallet(result.data.wallet);
            }
        } catch (error) {
            console.log("load contact error:", error);
        }
    }
    const onPayMayaTopup = async (values) => {
        onShowLoading(true);
        try {
            let timestamp = new Date().getTime();
            let body = {
                customer_id: contact.code,
                first_name: contact.first_name,
                last_name: contact.last_name,
                amount: values.amount,
                redirect_url_success: window.location.origin + portalCfg.basename  + paths.paymaya_redirect_url_success + "?timestamp=" + timestamp,
                redirect_url_failure: window.location.origin + portalCfg.basename  + paths.paymaya_redirect_url_failure + "?timestamp=" + timestamp,
                redirect_url_cancel: window.location.origin + portalCfg.basename  + paths.paymaya_redirect_url_dropout + "?timestamp=" + timestamp,
            }
            const result = await cignalservices.initiateTopUp(body);
            console.log("result:", result);
            if (result.code == 'OK') {
                onShowLoading(false);
                Cookies.set("paymaya_" + timestamp, result.data.request_reference_number, { expires: 10000 });
                window.location.href = result.data.paymaya_redirect_url;
            } else {
                showAlert(t('EXCEPTION_PROCESS'));
            }
        } catch (ex) {
            console.log("onPayMayaTopup ex:", ex)
            showAlert(t('EXCEPTION_PROCESS'));
        }
    }
    const on3DSecure = async (values) => {
        //topup 3D check
        onShowLoading(true);
        setPaymentFormData(null);
        setShowPaymentForm(false);
        var token = newGUID();
        let responseURL = window.location.origin + portalCfg.basename + '/process_topup/' + token;

        var paymentFormResult = await crmservices.account.createPaymentFormTopup({ topup_amount: Number(amount), payment_method_id: cardSelect.id, redirect_url: responseURL });
        if (paymentFormResult.code == 'OK') {
            let body = {
                token: token,
                wallet_id: wallet.id,
                amount: Number(amount),
                payment_method_id: cardSelect.id,
            }
            console.log('on3DSecure body==', body)
            setTopupInfo(body)
            setPaymentFormData(paymentFormResult.data);
            setShowPaymentForm(true);
        } else {
            showAlert(t('EXCEPTION_PROCESS'));
        }
        onShowLoading(false);
    }
    const onTopup = async (values) => {
        let date = (new Date()) / 1000;
        let body = {
            wallet_id: wallet.id,
            topup_date: date.toFixed(0),
            amount: Number(amount),
            payment_method_id: cardSelect.id,
        }
        try {
            onShowLoading(true);
            let result = await crmservices.account.topUpWallet(body);
            if (result.code == 'OK') {
                await onLoadWallet();
                showAlert(t('TOPUP_SUCCESS'))
                setAmount('');
            }
            else if (result.code == 'PAYMENT_GATEWAY_EXCEPTION') {
                showAlert(t('TOPUP_FAILED'))
            }
            else {
                showAlert(t('EXCEPTION_PROCESS'))
            }
        }
        catch (e) {
            console.log(' Topup Error: ', e)
            showAlert(t('EXCEPTION_PROCESS'))
        }
    }
    const onShowAddCard = async () => {
        if (!showAddCard) {
            onShowLoading(true);
            setShowAddCard(!showAddCard);
            try {
                var result = await crmservices.contacts.createFormToAddCard();
                // console.log(' onPrepareForm result===', result)
                if (result.code == 'OK') {
                    //window.document.write(result.data);
                    setHtmlAddCardConten(result.data);
                }
            } catch (error) {
                console.log("on create form to add card exception:", error);
            }
            onShowLoading(false);
        }
        else {
            setShowAddCard(!showAddCard)
            onShowLoading(true);
            await onLoadCards();
            onShowLoading(false);
        }

    }
    const showAlert = (message) => {
        onShowLoading(false);
        setError({
            showAlert: true,
            message: message,
        });
    }
    const onCloseAlert = () => {
        onShowLoading(false);
        setError({
            showAlert: false,
            message: '',
        });
    }
    const onShowPaymentForm = async () => {
        if (showPaymentForm) {
            onShowLoading(true);
            setShowPaymentForm(false);
            await onLoadWallet();
            onShowLoading(false);
        }
        else {
            setShowPaymentForm(true);
        }

    }
    const onChangeInput = (value) => {
        //console.log('onChangeInput====', value)
        setAmount(value);
    }
    const onChangeInputAutoWallet = (target, value) => {
        //console.log('onChangeInputAutoWallet====', value)
        //console.log('onChangeInputAutoWallet====', target)
        setAutomateInfo(prevState => ({
            ...prevState,
            [target]: value
        }))
    }
    const onAutomateWallet = async () => {

    }
    return (
        <div>
            <TopupWalletView
                showLoading={showLoading}
                open={props.open}
                currency={currency}
                onClose={props.onClose}
                onTopup={onTopup}
                cards={cards.sort(dataUtil.sortByCardPrimary)}
                cardSelect={cardSelect}
                wallet={wallet}
                onChangeInput={onChangeInput}
                amount={amount}
                setCardSelect={setCardSelect}
                onShowAddCard={onShowAddCard}
                on3DSecure={on3DSecure}
                onPayMayaTopup={onPayMayaTopup}
                setShowAutomateWallet={setShowAutomateWallet} />
            {showAddCard && <AddCard
                open={showAddCard}
                onClose={onShowAddCard}
                html_add_card_content={html_add_card_content} />}
            {showPaymentForm && <PaymentForm
                open={showPaymentForm}
                onClose={onShowPaymentForm}
                paymentFormData={paymentFormData}
            />}
            {showAutomateWallet && <AutomateWalletView
                open={showAutomateWallet}
                automateInfo={automateInfo}
                onAutomateWallet={onAutomateWallet}
                onChangeInputAutoWallet={onChangeInputAutoWallet}
                onClose={() => setShowAutomateWallet(false)} />}
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
            />
        </div>
    );
}
